class Loading {
    static loaderId = 'loading';
    static markup = `
        <!-- Loading -->
        <div id="loading" style="z-index: 1000">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    `;

    // Show the loader with a fade-in effect.
    static show() {
        let loader = document.getElementById(Loading.loaderId);
        if (!loader) {
            // Create the loader element if it doesn't exist.
            const container = document.createElement('div');
            container.innerHTML = Loading.markup.trim();
            loader = container.firstElementChild;
            document.body.appendChild(loader);
        }
        // Remove the hidden class and ensure opacity is 0 initially.
        loader.classList.remove('hidden');
        loader.style.opacity = 0;

        // Force a reflow to ensure the transition is applied.
        void loader.offsetWidth;

        // Then animate to full opacity.
        loader.style.opacity = 1;
    }

    // Hide the loader with a fade-out effect.
    static hide() {
        const loader = document.getElementById(Loading.loaderId);
        if (loader) {
            // Animate to opacity 0.
            loader.style.opacity = 0;
            // After the transition duration, add the hidden class.
            setTimeout(() => {
                loader.classList.add('hidden');
            }, 300); // This should match the duration-300 class (300ms).
        }
    }
}

window.Loading = Loading;